import type * as React from "react";
import { Box, Checkbox, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { COLORS } from "components/v3/Theme/colors";

const ANIMATION_DURATION_S = 0.5;

const REQUIRED_FIELDS_MESSAGE =
  "* Please complete all required fields above.";

const ATTESTATION_LABEL =
  "I confirm that the information provided above is accurate to the best of my knowledge.";

export type ProfileFormAccuracyAttestationBlockProps = {
  accuracyAttestationIsChecked: boolean;
  showAttestationCheckbox: boolean;
  onAccuracyAttestationChange: () => void;
};

const ProfileFormAccuracyAttestationBlock: React.FC<
  ProfileFormAccuracyAttestationBlockProps
> = ({
  showAttestationCheckbox,
  accuracyAttestationIsChecked,
  onAccuracyAttestationChange
}) => {
  const theme = useTheme();
  const showRequiredFieldsMessage = !showAttestationCheckbox;

  return (
    <Box
      sx={{
        minHeight: showRequiredFieldsMessage ? "2.75rem" : undefined,
        position: "relative",
        width: "100%"
      }}
    >
      {/* @ts-ignore: framer-motion v6 type definitions are incomplete */}
      <motion.div
        animate={{ opacity: showRequiredFieldsMessage ? 1 : 0 }}
        initial={false}
        transition={{ duration: ANIMATION_DURATION_S }}
        style={{
          left: 0,
          pointerEvents: "none",
          position: "absolute",
          right: 0,
          top: -10,
          zIndex: 0
        }}
      >
        <Typography
          component="p"
          variant="body_sm"
          sx={{
            color: theme.palette.error.main,
            fontStyle: "italic",
            lineHeight: 1.5,
            m: 0
          }}
        >
          {REQUIRED_FIELDS_MESSAGE}
        </Typography>
      </motion.div>
      {/* @ts-ignore: framer-motion v6 type definitions are incomplete */}
      <motion.div
        animate={
          showAttestationCheckbox
            ? { height: "auto", opacity: 1 }
            : { height: 0, opacity: 0 }
        }
        initial={{ height: 0, opacity: 0 }}
        transition={{ duration: ANIMATION_DURATION_S }}
        style={{
          backgroundColor: COLORS.WHITE,
          overflow: "hidden",
          position: "relative",
          zIndex: 1
        }}
      >
        <Box
          component="label"
          sx={{
            alignItems: "center",
            cursor: "pointer",
            display: "flex",
            gap: 1.5
          }}
        >
          <Checkbox
            checked={accuracyAttestationIsChecked}
            onChange={onAccuracyAttestationChange}
            sx={{ flexShrink: 0, p: 0.75 }}
          />
          <Typography variant="body_strong_black">{ATTESTATION_LABEL}</Typography>
        </Box>
      </motion.div>
    </Box>
  );
};

export default ProfileFormAccuracyAttestationBlock;
